// React-Screen CBonSaveMode ("BONS speichern" - der RKSV-DEP-Export) -
// Strangler Phase 5. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle bonsavemode.js (aus
// lib/scripts/pos/components/CMP_CBonSaveMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CBonSaveMode.html, gezogen aus
// tests/visual-baseline/24-overlay-bons-speichern.html (in der Baseline sind
// die Datums-ZIFFERN maskiert, sonst wuerde sie taeglich driften - Kaesten,
// Trenner und Positionen bleiben geprueft).
//
// RKSV: dieser Screen loest CReceipt.exportDEP aus. Der Ablauf bleibt
// zeichengenau erhalten, inklusive des Waechters gegen den stillen
// Fehlschlag ohne USB-Stick (20.8.2026).
//
// Zweiter Screen mit ECHTEN LEGACY-KIND-WIDGETS (spec.mountLegacy): die
// beiden Datumsfelder sind CMultiClickDate - allein sie bringen ueber 240
// DOM-Elemente mit. Sie in JSX nachzubauen hiesse, die Klick-Logik des
// Widgets zu duplizieren; stattdessen entstehen sie wie im Legacy und
// haengen sich hinter die React-Kinder (Begruendung im Kopf von bridge.js).
// Die beiden Beschriftungen VON:/BIS: gehoeren mit in mountLegacy, weil sie
// im Legacy NACH den Widgets addChild't werden und damit hinter ihnen im DOM
// stehen.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import { CMultiClickDate } from '../../components/multiclickdate.js';
import { CCaption } from '../../components/caption.js';
// Caption bringt dieser Screen selbst mit (siehe unten) - nur die
// Datumsfelder kommen aus dem gemeinsamen Baukasten.
import { MultiClickDate, verdrahteMultiClickDate } from '../widgets.jsx';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

function BonSaveModeScreen({ bridge }) {
  // Legacy: okButton.properties.events.onMousedown = this.saveBons
  const okButton = bridge.widget('7', 'CPushButton', {
    events: { onMousedown: () => bridge.saveBons(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });
  // Legacy: backButton.properties.events.onMousedown = this.finish
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: () => bridge.finish(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText - Legacy setzt hier einen festen String, keine Pipe-Datei */}
      <Caption bridge={bridge} path="3" addclass="titletext" value="BONS speichern" />
      {/* contentText */}
      <Caption bridge={bridge} path="4" addclass="contenttext" value=" " />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" value=" " />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      {/* okButton */}
      <div {...okButton} className="CPushButton okbutton">
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      {/* Kinder 9-12 (2x CMultiClickDate + VON:/BIS:) haengt spec.mountLegacy an */}
      {/* 9..12: zwei Datumsfelder und ihre Beschriftungen. Stile aus der
          BASELINE, nicht aus der XML - die Laufzeit-Zuweisungen von
          mountLegacy sind aus der XML nicht ableitbar. */}
      <MultiClickDate bridge={bridge} pfad="9" links="10vw" oben="7vw" />
      <MultiClickDate bridge={bridge} pfad="10" links="10vw" oben="14vw" />
      <Caption bridge={bridge} path="11" addclass="" value="VON:"
               style={{ position: 'absolute', left: '2vw', top: '9.5vw',
                        width: '3vw', color: '#000000', fontSize: '4.0vh' }} />
      <Caption bridge={bridge} path="12" addclass="" value="BIS:"
               style={{ position: 'absolute', left: '2.5vw', top: '16.5vw',
                        width: '3vw', color: '#000000', fontSize: '4.0vh' }} />
    </>
  );
}

export const CBonSaveMode = defineReactScreen({
  className: 'CBonSaveMode',
  addclass: 'CBonSaveMode CashWindow',
  htmlType: 'div',
  Screen: BonSaveModeScreen,
  prepare(bridge) {
    bridge.Main = POS.sessions.getSessionComponent();

    bridge.Main.components.payment.setEnabled(false);
    bridge.Main.components.payment2.setEnabled(false);
    bridge.Main.components.bonfnc.setEnabled(false);
    bridge.Main.components.leftPad.setEnabled(false);
    bridge.Main.components.bonedit.setEnabled(false);
  },
  // Legacy-prepare(), Widget-Teil: unveraendert uebernommen, nur eben nach
  // dem React-Mount - die Kinder-Indizes 9..12 stimmen dadurch von selbst.
  // Frueher entstanden hier vier ECHTE Legacy-Kinder (zwei CMultiClickDate,
  // zwei CCaption). Seit 25.8.2026 baut die JSX ihr DOM (Pfade 9..12) - hier
  // bleibt nur das VERHALTEN: verdrahteMultiClickDate haengt die
  // Legacy-Prototypen an die von React erzeugten Knoten, getValue()/setValue()
  // laufen danach WOERTLICH weiter. Nachgebaut ist nichts davon.
  mountLegacy(bridge) {
    bridge.mcd1 = verdrahteMultiClickDate(bridge, '9');
    bridge.mcd2 = verdrahteMultiClickDate(bridge, '10');
    var d = currentDateString('dd.mm.yy');
    bridge.mcd1.setValue(d);
    bridge.mcd2.setValue(d);
  },
  methods: {
    // OK: DEP-Export im gewaehlten Zeitraum auf den USB-Stick.
    saveBons(bridge) {
      var von = bridge.mcd1.getValue();
      var bis = bridge.mcd2.getValue();
      var vonparts = von.split('.');
      var bisparts = bis.split('.');
      var vondate = '20' + vonparts[2] + '-' + vonparts[1] + '-' + vonparts[0] + 'T' + '00:00:00';
      var bisdate = '20' + bisparts[2] + '-' + bisparts[1] + '-' + bisparts[0] + 'T' + '23:59:59';
      var Receipt = new CReceipt(null);
      $.when(Receipt.exportDEP(vondate, bisdate)).done(function (jsonstr) {
        if (jsonstr.length > 0) {
          var path = '/home/pos/usb/BelegeExport.txt';
          var wres = fs.writeFileSync(path, jsonstr);
          // Vorbestehender stiller Fehlschlag behoben (20.8.2026): ohne
          // gemounteten USB-Stick (/home/pos/usb -> /media/usbstick) kam
          // "NOK ENOENT..." zurueck, die Kasse meldete trotzdem Erfolg -
          // die Kassiererin glaubte, die Finanz-Belege exportiert zu haben.
          if (typeof wres == 'string' && wres.indexOf('NOK') == 0) {
            POS.message.show('Export FEHLGESCHLAGEN - USB-Stick angeschlossen?', 'warning', 'OK');
            return;
          }
          var text = 'Belege exportiert!';
          POS.message.show(text, 'warning', 'OK');
        }
      });
    },
    finish(bridge) {
      bridge.Main.components.payment.setEnabled(true);
      bridge.Main.components.payment2.setEnabled(true);
      bridge.Main.components.bonfnc.setEnabled(true);
      bridge.Main.components.leftPad.setEnabled(true);
      bridge.Main.components.bonedit.setEnabled(true);

      bridge.removeMe();
    },
  },
});
